import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Budget } from './Budget';
import { Project } from './Project';

export class BudgetProject extends Model {
    static backendResourceName = 'budget_project';
    static omitFields = []

    @observable id = null;

    @observable budget = this.relation(Budget);
    @observable project = this.relation(Project);
    @observable percentage = 0;
}

export class BudgetProjectStore extends Store {
    Model = BudgetProject;
    static backendResourceName = 'budget_project';
}
